var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAction, createAsyncThunk, } from '@reduxjs/toolkit';
import { ChatService } from '../chat.service';
const setStatus = createAction('chat/setStatus');
export const loadChat = createAsyncThunk('core/chat/loadChat', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { dispatch, extra: { inject } }) {
    try {
        dispatch(setStatus('loading'));
        const service = inject(ChatService);
        const credentials = yield service.getSupportCredentials();
        const script = document.createElement('script');
        window.webim = {
            accountName: window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME,
            domain: `${window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME}.webim.ru`,
            location: 'hr_box',
        };
        window.webim_visitor = credentials;
        script.type = 'text/javascript';
        script.defer = true;
        script.src = `https://${window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME}.webim.ru/js/button.js`;
        document.head.appendChild(script);
        const intervalTime = 100;
        const intervalId = setInterval(() => {
            if (window.webim.api && document.querySelector('.webim-button-corner')) {
                dispatch(setStatus('complete'));
                window.webim.api.chat.start();
                clearInterval(intervalId);
            }
        }, intervalTime);
    }
    catch (e) {
        dispatch(setStatus('failed'));
    }
}));
export const chatReducers = (builder) => {
    builder.addCase(setStatus, (state, action) => {
        state.status = action.payload;
    });
};
